<script lang="ts">
import FicheDocumentViewer from '@/generated/fiches/FicheDocumentViewer.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheDocumentViewer
})

</script>
